import {abandonChat, AbandonChatRequest} from './chat';
import {Api} from './api';
import {AppProfile} from '../../types';
import {
  cancelRequestACall,
  fetchRequestACallCodes,
  fetchVerificationCodes,
  inProgressRequestACall,
  inProgressRequestACallV2,
  requestACall,
  RequestACallRequest,
} from './request-a-call';
import {ClientFetch} from '../util/clientFetch';
import {ContactFormEndpointRequest} from '../../../generated/types';
import {
  createCSATSurvey,
  CreateCSATSurveyRequest,
  submitCSATRating,
  SubmitCSATRatingRequest,
} from './csat';
import {endConversation} from './end-conversation';
import {fetchConnectPlatformTransparency} from './connect-platform';
import {fetchEligibleChannels} from './channels';
import {
  fetchFeedback,
  FetchFeedbackRequest,
  submitFeedback,
  SubmitFeedbackRequest,
} from './feedback';
import {fetchProfile, FetchProfileRequest} from './profile';
import {fetchTopics} from './topics';
import {listConversations, ListConversationsRequest} from './conversations';
import {submitContactForm} from './email';

export function createApi(
  fetch: ClientFetch,
  _getProfile: () => AppProfile,
): Api {
  const isLoggedOut = () => false;

  return {
    fetch,
    fetchEligibleChannels: (
      entryPoint: string,
      audience: string,
      uhConversationId: string | undefined,
    ) => fetchEligibleChannels(fetch, entryPoint, audience, uhConversationId),
    fetchTopics: (entryPoint: string) => fetchTopics(fetch, entryPoint),
    fetchConnectPlatformTransparency: () =>
      fetchConnectPlatformTransparency(fetch),
    listConversations: (request: ListConversationsRequest) =>
      listConversations(fetch, request),

    fetchProfile: (request: FetchProfileRequest) =>
      fetchProfile(fetch, request),

    createCSATSurvey: (request: CreateCSATSurveyRequest) =>
      createCSATSurvey(fetch, request),
    submitCSATRating: (request: SubmitCSATRatingRequest) =>
      submitCSATRating(fetch, request),

    fetchFeedback: (request: FetchFeedbackRequest) =>
      fetchFeedback(fetch, request),
    submitFeedback: (request: SubmitFeedbackRequest) =>
      submitFeedback(fetch, request),

    submitContactForm: (body: ContactFormEndpointRequest) =>
      submitContactForm(fetch, body),

    inProgressRequestACall: (
      entryPoint: string,
      audience: string,
      uhConversationId: string | undefined,
    ) => {
      if (isLoggedOut() && !uhConversationId) {
        return Promise.resolve({code: 200, data: {inProgress: false}});
      }

      return inProgressRequestACall(
        fetch,
        entryPoint,
        audience,
        uhConversationId,
      );
    },
    inProgressRequestACallV2: (
      entryPoint: string,
      uhConversationId: string | undefined,
    ) => {
      if (isLoggedOut() && !uhConversationId) {
        return Promise.resolve({code: 200, data: {inProgress: false}});
      }

      return inProgressRequestACallV2(fetch, entryPoint, uhConversationId);
    },
    requestACall: (request: RequestACallRequest) =>
      requestACall(fetch, request),
    fetchVerificationCodes: (audience: string) =>
      fetchVerificationCodes(fetch, audience),
    fetchRequestACallCodes: (
      entryPoint: string,
      uhConversationId: string | undefined,
    ) => {
      if (isLoggedOut() && !uhConversationId) {
        return Promise.resolve({type: 'success', pending: false});
      }

      return fetchRequestACallCodes(fetch, entryPoint, uhConversationId);
    },
    cancelRequestACall: (
      entryPoint: string,
      uhConversationId: string | undefined,
    ) => cancelRequestACall(fetch, entryPoint, uhConversationId),
    abandonChat: (request: AbandonChatRequest) => abandonChat(fetch, request),
    endConversation: (conversationId: string) =>
      endConversation(fetch, conversationId),
  };
}
